module.exports = __webpack_public_path__ + "files/SPIADI2026 - Annexe Score de sévérité.cbd1775b3794ddca7f51874c1511f94b.pdf";